import {
  getTransactionDetails,
  getFinancialTransaction,
  getClientBillMaster,
  sendBillMasterEmail,
  getBillDetails,
  createAdjustments,
} from "@/http/customer/customer";

export default {
  namespaced: true,
  state: {
    billMaster: [],
    transactionDetails: [],
    billDetail: [],
  },
  actions: {
    async setTransactionDetails({ commit }, data) {
      const resp = await getTransactionDetails(data.params, data.clientId);
      commit("SET_TRANSACTION_DETAILS", resp.data.pageItems);
      return resp;
    },
    async getFinancialTransactionAction(_, id) {
      const response = await getFinancialTransaction(id);
      return response;
    },
    async setBillMasterData({ commit }, data) {
      const resp = await getClientBillMaster(data);
      commit("SET_CLIENT_BILL_MASTER_DATA", resp.data.pageItems);
      return resp;
    },
    async sendBillMasterEmail(_, data) {
      const res = await sendBillMasterEmail(data.id, data.data);
      return res;
    },
    async createAdjustmentsAction(_, data) {
      return await createAdjustments(data);
    },
    async setViewBillDetail({ commit }, data) {
      const resp = await getBillDetails(data);
      commit("SET_VIEW_BILL_DETAIL", resp.data);
      return resp;
    },
  },
  mutations: {
    SET_TRANSACTION_DETAILS(state, payload) {
      state.transactionDetails = payload;
    },
    SET_CLIENT_BILL_MASTER_DATA(state, payload) {
      state.billMaster = payload;
    },
    SET_VIEW_BILL_DETAIL(state, payload) {
      state.billDetail = payload;
    },
  },
  getters: {
    getTransactionDetails(state) {
      return state.transactionDetails;
    },
    getBillMasterData(state) {
      return state.billMaster;
    },
    getBillDetailData(state) {
      return state.billDetail;
    },
  },
};
